export default "__VITE_ASSET__Cl67Uh68__"